import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar: React.FC = () => {
  const location = useLocation();
  const { logout, user } = useAuth();

  const handleLogout = async (): Promise<void> => {
    await logout();
  };

  const isActive = (path: string): boolean => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  // Check if user is admin
  const isAdmin = user?.role === 'admin';

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <a href="/dashboard" className="brand-link">
        <img 
          src="/logo-bunny.png" 
          alt="PsicoAdm Logo" 
          className="brand-image img-circle elevation-3" 
          style={{ opacity: 0.8 }}
        />
        <span className="brand-text font-weight-light">PsicoAdm</span>
      </a>

      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {/* Admin users only see admin pages */}
            {isAdmin ? (
              <>
                <li className="nav-header">ADMINISTRAÇÃO DO SISTEMA</li>
                <li className="nav-item">
                  <a href="/admin/companies" className={`nav-link ${isActive('/admin/companies') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-building"></i>
                    <p>Empresas</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/admin/users" className={`nav-link ${isActive('/admin/users') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-user-cog"></i>
                    <p>Usuários</p>
                  </a>
                </li>
              </>
            ) : (
              <>
                {/* Regular users and managers see operational pages */}
                <li className="nav-item">
                  <a href="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-home"></i>
                    <p>Página Inicial</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/patients" className={`nav-link ${isActive('/patients') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-users"></i>
                    <p>Pacientes</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/appointments" className={`nav-link ${isActive('/appointments') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-calendar-alt"></i>
                    <p>Agendamentos</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/medical-records" className={`nav-link ${isActive('/medical-records') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-file-medical"></i>
                    <p>Prontuários</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/financial" className={`nav-link ${isActive('/financial') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-chart-line"></i>
                    <p>Balanço Financeiro</p>
                  </a>
                </li>
                
                {/* Manager can also manage users of their company */}
                {user?.role === 'manager' && (
                  <>
                    <li className="nav-header">GERENCIAMENTO</li>
                    <li className="nav-item">
                      <a href="/admin/users" className={`nav-link ${isActive('/admin/users') ? 'active' : ''}`}>
                        <i className="nav-icon fas fa-user-cog"></i>
                        <p>Usuários da Empresa</p>
                      </a>
                    </li>
                  </>
                )}
              </>
            )}
          </ul>
        </nav>

        {/* Logout button at bottom */}
        <nav className="mt-2" style={{ position: 'absolute', bottom: 0, width: '100%' }}>
          <ul className="nav nav-pills nav-sidebar flex-column">
            <li className="nav-item">
              <button 
                onClick={handleLogout}
                className="nav-link btn btn-link w-100 text-left"
                type="button"
                style={{ border: 'none', background: 'none', padding: '0.5rem 1rem' }}
              >
                <i className="nav-icon fas fa-sign-out-alt"></i>
                <p>Sair</p>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;